import(/* webpackMode: "eager" */ "/vercel/path0/app/(public)/project/page.tsx");
